import { memoize } from 'lodash'
import * as apiCalls from './calls'

// Bind object \w give proxy function...
const bindObject = (obj, proxy) => {
  const keys = Object.keys(obj)
  const boundObj = {}
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const fn = obj[key]
    if (typeof fn === 'function') {
      boundObj[key] = proxy(fn)
    }
  }
  return boundObj
}

// Bind api calls \w curried token
const bindApiCalls = memoize(token =>
  bindObject(apiCalls, fn => {
    const authCurryFn = fn(token)
    return (...args) => authCurryFn(...args)
  })
)

export const makeAuthenticatedApi = state => {
  // Auth token from redux state
  const token = state.auth.accessToken

  return bindApiCalls(token)
}



// WEBPACK FOOTER //
// ./src/api/make.js